import { css } from '@emotion/react';
import styled, { type CSSObject } from '@emotion/styled';

export const ColumnEditorContainer = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
`;

export const LeftColumn = styled.div`
  width: 340px;
  overflow-y: auto;
  padding: 2rem 1.5rem;
`;

export const RightColumn = styled.div`
  flex: 1;
  overflow: auto;
  background: #fff;
  border-left: 1px solid #dddfe2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const RightColumnCCP = styled.div`
  flex: 1;
  overflow: auto;
  border-left: 1px solid #dddfe2;
`;

export const RightColumnFullPreview = styled.div`
  flex: 1;
  overflow: hidden;
  background: #fff;
  display: flex;
  overflow-y: auto;
`;

export const EditorTopTitle = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  margin-bottom: 10px;
`;

export const TabListStyles = css({
  backgroundColor: '#fff',
  border: '1px solid #dddfe2',
  borderRadius: '4px',
  margin: '0 0 10px',
  padding: '0',
  listStyle: 'none',
  display: 'flex',
  flexWrap: 'wrap',
});

export const TabListStylesFixed = css`
  .react-tabs__tab-list {
    background-color: #fff;
    border-top: 1px solid #dddfe2;
    border-bottom: 1px solid #dddfe2;
    border-radius: 0;
    margin: 0 0 10px;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    position: sticky;
    top: 0;
    z-index: 5000;
  }
`;

export const EditTabStyles = css({
  minHeight: 49,
});

// Editors like "placement"
export const CenterEditor: Record<string, CSSObject> = {
  mainContainer: {
    padding: '1rem',
  },
  flexMainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  container: {
    border: '1px solid #DDDFE2',
    width: '100%',
    maxWidth: 762,
    background: '#fff',
    fontSize: 15,
  },
  columnTitle: {
    fontSize: 14,
    color: 'rgba(0,0,0,0.5)',
  },
  groupTitle: {
    fontSize: 16,
    color: 'rgba(0,0,0,1)',
    padding: '1rem 1.5rem',
    paddingBottom: 0,
    fontWeight: 'bold',
  },
  groupSubtitle: { fontSize: 14, padding: '0px 1.5rem 1rem' },
  groupSpacing: { padding: '0px 1.5rem 1rem' },
  rowGroupSubtitle: {
    padding: '1rem 1.5rem',
    paddingBottom: 0,
    fontSize: 16,
    color: 'rgba(0,0,0,1)',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  rowGroup: { padding: '1.5rem 0' },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '.6rem 1.5rem',
  },
  colorRow: {
    '&:nth-of-type(odd)': {
      background: 'rgba(0,0,0,0.05)',
    },
  },
  colorRowEven: {
    '&:nth-of-type(even)': {
      background: 'rgba(0,0,0,0.05)',
    },
  },
  rowLeftColumn: {
    width: '65%',
    paddingRight: '1rem',
  },
  rowRightColumn: {
    width: '35%',
  },
  columnContent: {
    fontSize: 13,
  },
};
